const phrases = [
  { text: "find buyers. win attention. close deals.", style: "editorial" },
  { text: "people. systems. creativity.", style: "stroke" },
  { text: "less admin. more time selling.", style: "editorial" },
  { text: "live in two weeks", style: "stroke" },
  { text: "2x faster. 2x engagement.", style: "editorial" },
];

const Row = ({ items }) => (
  <>
    {items.map((p, i) => (
      <span
        key={i}
        className={`inline-block px-8 leading-none uppercase text-6xl md:text-8xl lg:text-[9rem] ${
          p.style === "stroke"
            ? "font-display font-semibold text-stroke-paper"
            : "font-editorial italic font-medium text-cobalt"
        }`}
      >
        {p.text}
        <span className="text-flame not-italic"> ✳ </span>
      </span>
    ))}
  </>
);

export const EditorialMarquee = () => {
  const loop = [...phrases, ...phrases];

  return (
    <section
      className="bg-ink text-paper py-8 md:py-12 border-y border-ink select-none overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="overflow-hidden" data-testid="editorial-marquee-track">
        <div className="flex w-max whitespace-nowrap animate-marquee motion-reduce:animate-none will-change-transform hover:[animation-play-state:paused]">
          <Row items={loop} />
          <Row items={loop} />
        </div>
      </div>
    </section>
  );
};
